import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useNoIndex } from "@/components/accordi/accordiUtils";
import { toast } from "sonner";
import { Loader2, LockKeyhole } from "lucide-react";

const Shell = ({ title, children, testid }) => (
  <div className="flex min-h-screen items-center justify-center bg-bone px-4" data-testid={testid}>
    <div className="w-full max-w-md space-y-5 rounded-2xl border bg-white p-8 shadow-sm">
      <img src="/assets/assietica-logo.png" alt="Assietica" className="h-9" />
      <h1 className="flex items-center gap-2 font-heading text-2xl font-semibold text-forest"><LockKeyhole className="h-5 w-5 text-terracotta" />{title}</h1>
      {children}
    </div>
  </div>
);

// Login referente ente (realm separato dallo staff) + password dimenticata.
export function ReferenteLogin() {
  const navigate = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  useNoIndex();
  useEffect(() => { api.get("/referente/me").then(() => navigate("/referente/dashboard", { replace: true })).catch(() => {}); }, []); // eslint-disable-line
  const login = async () => {
    setBusy(true);
    try { await api.post("/referente/login", f); navigate("/referente/dashboard"); } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const dimenticata = async () => {
    if (!f.email) { toast.info("Inserisci prima la tua email"); return; }
    const { data } = await api.post("/referente/password-dimenticata", { email: f.email, origin: window.location.origin });
    toast.success(data.message);
  };
  return (
    <Shell title="Dashboard dell'accordo" testid="referente-login">
      <p className="text-sm text-muted-foreground">Accesso riservato ai referenti degli enti convenzionati.</p>
      <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="referente-email" /></div>
      <div className="space-y-1.5"><Label>Password</Label><Input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} onKeyDown={(e) => e.key === "Enter" && login()} data-testid="referente-password" /></div>
      <Button onClick={login} disabled={busy || !f.email || !f.password} data-testid="referente-accedi" className="h-11 w-full bg-terracotta hover:bg-terracotta-hover">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Accedi</Button>
      <button onClick={dimenticata} data-testid="referente-dimenticata" className="w-full text-center text-sm text-forest hover:underline">Password dimenticata?</button>
    </Shell>
  );
}

// Attivazione da invito / reimpostazione password.
export function ReferenteAttiva() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);
  useNoIndex();
  const attiva = async () => {
    if (pwd !== pwd2) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try { await api.post("/referente/attiva", { token, password: pwd }); toast.success("Password impostata: ora puoi accedere"); navigate("/referente"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Scegli la tua password" testid="referente-attiva">
      <p className="text-sm text-muted-foreground">Almeno 8 caratteri, con lettere e numeri.</p>
      <div className="space-y-1.5"><Label>Nuova password</Label><Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="attiva-password" /></div>
      <div className="space-y-1.5"><Label>Ripeti password</Label><Input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="attiva-password2" /></div>
      <Button onClick={attiva} disabled={busy || !pwd} data-testid="attiva-conferma" className="h-11 w-full bg-forest hover:bg-forest-hover">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Imposta password</Button>
    </Shell>
  );
}
